var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPledgeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#F7F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 17H23C22.4696 17 21.9609 17.2107 21.5858 17.5858C21.2107 17.9609 21 18.4696 21 19V31C21 31.5304 21.2107 32.0391 21.5858 32.4142C21.9609 32.7893 22.4696 33 23 33H35C35.5304 33 36.0391 32.7893 36.4142 32.4142C36.7893 32.0391 37 31.5304 37 31V19C37 18.4696 36.7893 17.9609 36.4142 17.5858C36.0391 17.2107 35.5304 17 35 17ZM29 19.5C29.663 19.5 30.2989 19.7634 30.7678 20.2322C31.2366 20.7011 31.5 21.337 31.5 22C31.5 22.663 31.2366 23.2989 30.7678 23.7678C30.2989 24.2366 29.663 24.5 29 24.5C28.337 24.5 27.7011 24.2366 27.2322 23.7678C26.7634 23.2989 26.5 22.663 26.5 22C26.5 21.337 26.7634 20.7011 27.2322 20.2322C27.7011 19.7634 28.337 19.5 29 19.5ZM34 30H24V29.75C24 27.901 26.254 26 29 26C31.746 26 34 27.901 34 29.75V30Z",
    fill: "#4158BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H17V35C17 36.103 17.897 37 19 37H31V35H19V23Z",
    fill: "#94A8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPledgeLogo);
export default __webpack_public_path__ + "static/media/pledge_logo.a2c5f841e6d1277b12266a78ccf35a7a.svg";
export { ForwardRef as ReactComponent };